import _ from 'underscore'
import Backbone from '@polleverywhere/backbone'
import Provider from './provider'

import google from './google'
import apple from './apple'

const PROVIDER_CONFIG = {
  google,
  apple
}

function getLabel (provider, labelName) {
  return provider.labels[labelName]
}

export default class SSOProviders extends Backbone.View {
  get className () { return 'component-auth__sso-providers' }

  /**
  * @param {Object} options Configuration options.
  * @param {String} options.labelName The name of the label to display on each
  *   provider button
  * @param {Object<string, Object>} options.providers Hash of sso providers
  * @param {Function} options.providers[].callbackFn Function is called with an
  *   Oauth2Redirect instance when the provider button is clicked. It is this
  *   function's responsibility to redirect the client to the oauth2 redirect
  *   url
  */
  initialize (options = {}) {
    this.options = _.defaults(options, {
      providers: {},
      labelName: 'signIn'
    })

    this.providers = Object.entries(this.options.providers)
      .map(([name, { callbackFn }]) => {
        const providerConfig = PROVIDER_CONFIG[name]

        if (!providerConfig) {
          throw new Error(`SSO provider '${name}' not supported`)
        }

        const label = getLabel(providerConfig, this.options.labelName)
        const provider = new Provider(Object.assign({ label, callbackFn }, providerConfig))
        provider.on('all', this.trigger.bind(this))

        return provider
      })
  }

  render () {
    this.providers.map(provider =>
      this.$el.append(provider.render().$el)
    )
    return this
  }

  remove () {
    this.providers.map(provider =>
      provider.remove()
    )
    super.remove()
  }
}
